import { SET_ROUTE } from "../types";
import IRoute from "../../interfaces/IRoute";

export const setRoute = (payload: IRoute) => ({type: SET_ROUTE, payload});